import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { saveTransmitter } from '../actions/SaveTransmitter';
import { createTransmitter } from '../actions/CreateTransmitter';
import { deleteTransmitter } from '../actions/DeleteTransmitter';
import { FormGroup } from '../components/FormGroup';
import { FormRow } from '../components/FormRow';
import { RadioButtons } from '../components/RadioButtons';
import { hideDialog } from '../reducers/app';
import { setEditTransmitterDialogCode, setEditTransmitterDialogComment, setEditTransmitterDialogKind, setEditTransmitterDialogTitle, setEditTransmitterDialogUnit } from '../reducers/edit_transmitter_dialog';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa s\u00E4ndare" }));
export const DialogTransmitterEdit = (_props) => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_transmitter_dialog);
    /*
    if (dialog.id == null) {
        dialog.id = undefined;
    }

    if (dialog.code == null) {
        dialog.code = '';
    }

    if (dialog.unit == null) {
        dialog.unit = '';
    }
*/
    let footerleft, footerright;
    const radiobuttons = [
        { kind: 'onoff', title: 'På/Av' },
        { kind: 'dim', title: 'Dimmer' },
        { kind: 'rollershade', title: 'Rullgardin' }
    ];
    if (dialog.id) {
        footerleft = (_jsx(DeleteButton, { onClick: () => dispatch(deleteTransmitter()) }, "delete"));
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(saveTransmitter()) }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createTransmitter()) }, "create"))
        ];
    }
    return (_jsxs(Dialog, { id: "transmitter-edit", title: "Redigera s\u00E4ndare", footerleft: footerleft, footerright: footerright, children: [_jsx(FormRow, { children: _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: dialog.title, onChange: event => dispatch(setEditTransmitterDialogTitle(event.target.value)) }) }) }), _jsx(FormRow, { children: _jsx(RadioButtons, { buttons: radiobuttons, name: 'kind', kind: dialog.kind, updateKind: v => dispatch(setEditTransmitterDialogKind(v)) }) }), _jsx(FormRow, { children: _jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr' }, children: [_jsx("div", { style: { marginRight: '15px' }, children: _jsx(FormGroup, { label: "Kod", children: _jsx("input", { type: "text", name: "code", value: dialog.code, onChange: event => dispatch(setEditTransmitterDialogCode(event.target.value)) }) }) }), _jsx("div", { style: { marginLeft: '15px' }, children: _jsx(FormGroup, { label: "Knapp", children: _jsx("input", { type: "text", name: "unit", value: dialog.unit, onChange: event => dispatch(setEditTransmitterDialogUnit(event.target.value)) }) }) })] }) }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Kommentar", children: _jsx("input", { type: "text", name: "comment", value: dialog.comment, onChange: event => dispatch(setEditTransmitterDialogComment(event.target.value)) }) }) }), _jsx("input", { name: "transmitter_id", type: "hidden", value: dialog.id })] }));
};
